export const SDK_VERSION = '7.45.0';
